module.exports = __webpack_public_path__ + "images/polestar_small3e1fa306e1e72de18498b3a555dfc290.png";